import { Outlet } from 'react-router-dom'
import { Header } from './Header'

/** Shell for the appointment/meeting-link/establishment routes. */
export function AppointmentLayout() {
  return (
    <div className="h-auto min-h-screen flex flex-col bg-blue-50">
      <Header />
      <Outlet />
    </div>
  )
}
